@defer (when timeline()) {
  <section class="timeline">
    @for (item of timeline(); track item) {
      <div class="action">
        <div>
          <p [style.color]="item.colour">
            @if (item.icon) {
              <i class="mdi {{ item.icon }}"></i>
            }
            @if (item.logo) {
              <img width="24px" src="assets/svg/elogbooks-logo.svg" />
            }
          </p>

          <span class="connector">
            @if (item.connector === '|') {
              <i class="mdi mdi-arrow-down"></i>
            }
          </span>
        </div>
        <div>
          <p [innerHTML]="item.words"></p>
          <p class="date">
            @if (item.date) {
              <span>{{ item.date | amDateFormat: 'DD MMM YYYY HH:mm' }}</span>
            }
            @if (item.name) {
              <span>
                <i
                  >, <span class="">{{ item.name }}</span>
                </i></span
              >
            }
          </p>
        </div>
      </div>
    }
  </section>
}
